import { AdditionalPageOptions } from '../interface';

/**
 * Get CMS config from additionalPageOptions
 * @returns {object} - CMS config
 */
export const getCMSConfig = (): Partial<AdditionalPageOptions> =>
    window.additionalPageOptions || {};
